var render = function () {
  var _ref;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: [_vm.$style.container, (_ref = {}, _ref[_vm.$style.active] = _vm.active, _ref)]
  }, [_c('div', {
    class: [_vm.$style[_vm.type], _vm.$style.filled]
  }, [_c('base-icon', {
    attrs: {
      "name": "basic_".concat(_vm.type, "-filled")
    }
  })], 1), _c('div', {
    class: [_vm.$style[_vm.type], _vm.$style.filled]
  }, [_c('base-icon', {
    attrs: {
      "name": "basic_".concat(_vm.type, "-filled")
    }
  })], 1), _c('div', {
    class: _vm.$style[_vm.type]
  }, [_c('base-icon', {
    attrs: {
      "name": "basic_".concat(_vm.type)
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }